export const hasWalletManualAdjustment = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_WALLET_MANUAL_ADJUSTMENT' &&
      !!permission.status,
  );
};
